/** 학사일정 공휴일·휴업일 메모 최대 길이(연간시간표 1~10교시 표시와 맞춤) */
export const MAX_CALENDAR_HOLIDAY_NOTE_CHARS = 10;

/** 저장·표시용: 앞뒤 공백 제거 후 최대 길이로 자름 */
export function clampCalendarHolidayNote(raw: string | null | undefined): string {
  return Array.from((raw ?? '').trim()).slice(0, MAX_CALENDAR_HOLIDAY_NOTE_CHARS).join('');
}

/** 입력 중: 공백 유지, 길이만 제한 */
export function limitHolidayNoteInput(raw: string): string {
  return Array.from(raw).slice(0, MAX_CALENDAR_HOLIDAY_NOTE_CHARS).join('');
}
